<app-http-loader />
<app-payment-successful />
<router-outlet />
<footer>
  <app-footer />
</footer>
